// removed by extract-text-webpack-plugin
module.exports = {"container":"dashboard__container___2JyA3","dashboard":"dashboard__dashboard___3otJX","usage-container":"dashboard__usage-container___2FLpi","upload":"dashboard__upload___1a556","ruler":"dashboard__ruler___14wDP"};


//////////////////
// WEBPACK FOOTER
// ./src/scss/components/dashboard/dashboard.scss
// module id = 322
// module chunks = 0